// Plugins
import i18n from '@/plugins/i18n'

export default function(user) {
    let reportTypes = [];

    reportTypes.push({
        value: "faculty-comparison-report",
        text: '1- '+i18n.t("faculty_comparison_report"),
        permission: "promotionalprocess_facultycomparisonreport",
    });

    reportTypes.push({
        value: "candidate-survey-count-report",
        text: '2- '+i18n.t("promotional_process_candidate_survey_count_report"),
        permission: "promotionalprocess_candidatesurveycountreport",
    });

    reportTypes.push({
        value: "candidate-first-choice-survey-count-report",
        text: '3- '+i18n.t("promotional_process_candidate_first_choice_survey_count_report"),
        permission: "promotionalprocess_candidatefirstchoicesurveycountreport",
    });

    return reportTypes;

}


